var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5858 4.99985L19 3.41406L17.5859 4.82817L19.1717 6.41396L20.5858 4.99985ZM8 12.9998L16.1717 4.82817L16.1716 4.82805L16.8787 4.12094L16.8788 4.12106L18.2929 2.70696C18.6834 2.31643 19.3166 2.31643 19.7071 2.70696L21.2929 4.29274C21.6834 4.68327 21.6834 5.31643 21.2929 5.70696L11 15.9998L8 15.9998V12.9998ZM18.4646 7.12106L16.8788 5.53528L9 13.4141L9 14.9998H10.5858L18.4646 7.12106ZM1 4.99985H6V9.99985H1V4.99985ZM0 10.9998V3.99985H7V10.9998H4V18.4998C4 19.3283 4.67158 19.9998 5.5 19.9998H13.0354C13.2781 18.3037 14.7368 16.9998 16.5 16.9998C18.433 16.9998 20 18.5669 20 20.4998C20 22.4328 18.433 23.9998 16.5 23.9998C14.7368 23.9998 13.2781 22.696 13.0354 20.9998H5.5C4.11929 20.9998 3 19.8806 3 18.4998L3 10.9998H0ZM14 20.4998C14 21.8806 15.1193 22.9998 16.5 22.9998C17.8807 22.9998 19 21.8806 19 20.4998C19 19.1191 17.8807 17.9998 16.5 17.9998C15.1193 17.9998 14 19.1191 14 20.4998Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.fd4bb6a3.svg";
export { ForwardRef as ReactComponent };